import { useContext, useState } from 'react';
import MenuItem from './MenuItem';
import { UserContext } from '@context/createContext.jsx';
import { useNavigate } from 'react-router-dom';
import { logout } from '@services/Api.js';
import ToastError from '../modules/toast/ToastError.jsx';
import { deleteAllCookies } from '@helper/functions.js';
import { sidebarDesktop } from '@/constants/sidebarData';
import ConfirmationModal from '@core/ConfirmationModal';
import DefaultImageUser from '../modules/Default-Image/DefaultImageUser';
import ToastSuccess from '../modules/toast/ToastSuccess';

export default function Sidebar() {
  const {
    realEstate,
    clearUser,
    user: { _id, fullname, userType, profilePicture, realState },
  } = useContext(UserContext);
  const [openModal, setOpenModal] = useState(false);

  const navigate = useNavigate();

  const logoutHandler = async () => {
    await deleteAllCookies();
    await logout();
    await clearUser();
    navigate('/login', { replace: true });
  };

  const navigateSubdomain = () => {
    if (userType == 'agent') {
      if (!realEstate.subdomain || !realEstate.color) {
        ToastError({ content: 'اطلاعات املاک شما کامل نیست' });
      } else {
        window.open(`/${realEstate.subdomain}/list-agents/agent/${_id}`, '_blank', 'noopener,noreferrer');
      }
    } else {
      if (!realEstate.subdomain) {
        ToastError({ content: 'برای سایت املاک هنوز آدرسی ثبت نشده' });
        navigate('settings#SiteSubdomain');
      } else if (!realEstate.color) {
        ToastError({ content: 'برای سایت املاک هنوز رنگ سازمانی ثبت نشده' });
        navigate('settings#OrganizationalColor');
      } else {
        window.open(`/${realEstate.subdomain}`, '_blank');
      }
    }
  };

  return (
    <div className="w-60 h-screen bg-white px-4 pt-3.5 flex flex-col justify-between max-lg:hidden border-l-[1px] border-light-grey">
      <div className="flex flex-col pt-7">
        <div className="flex flex-row items-center gap-2 mb-5 px-2">
          <div className="flex flex-row items-center gap-2 text-sm md:text-base">
            <div className="h-10 w-10 max-sm:h-8 max-sm:w-8 rounded-full overflow-hidden">
              {profilePicture === '' ? (
                <DefaultImageUser />
              ) : (
                <img
                  src={`${import.meta.env.VITE_API_URL}/${profilePicture}`}
                  className="w-full h-full rounded-full"
                  alt="profile"
                />
              )}
            </div>
            <p className="text-blackFont-800 whitespace-nowrap line-clamp-1">{fullname}</p>
          </div>
        </div>
        <div className="flex flex-col gap-3">
          {userType == 'agent' &&
            sidebarDesktop
              .filter((item) => item.agent === true)
              .map((i) => <MenuItem realState={realState} key={i.id} {...i} />)}

          {userType == 'realStateOwner' &&
            sidebarDesktop
              .filter((item) => item.rsOwner === true)
              .map((i) => <MenuItem realState={realState} key={i.id} {...i} />)}
        </div>
      </div>
      <div className="w-full flex flex-col items-start mb-5 gap-2">
        <button
          disabled={!realState}
          // onClick={navigateSubdomain}
          className="w-full mx-auto text-sm text-text-normal disabled:bg-light-grey disabled:cursor-not-allowed transition-all hover:bg-gray border-[1px] border-light-grey rounded-lg py-2 hidden flex-row items-center justify-center px-3 gap-3 cursor-pointer"
        >
          <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M10.5 16.9498H6.71C3.34 16.9498 2.5 16.1098 2.5 12.7398V6.73979C2.5 3.36979 3.34 2.52979 6.71 2.52979H17.24C20.61 2.52979 21.45 3.36979 21.45 6.73979"
              stroke="#616161"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10.5 21.4702V16.9502"
              stroke="#616161"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M2.5 12.9502H10.5"
              stroke="#616161"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7.24023 21.4702H10.5002"
              stroke="#616161"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M22.5003 12.7998V18.5098C22.5003 20.8798 21.9103 21.4698 19.5403 21.4698H15.9903C13.6203 21.4698 13.0303 20.8798 13.0303 18.5098V12.7998C13.0303 10.4298 13.6203 9.83984 15.9903 9.83984H19.5403C21.9103 9.83984 22.5003 10.4298 22.5003 12.7998Z"
              stroke="#616161"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M17.7441 18.25H17.7531"
              stroke="#616161"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <p>نمایش سایت من</p>
        </button>

        <div
          onClick={(e) => {
            setOpenModal(true);
          }}
          className="w-full mx-auto text-sm text-error transition-all hover:border-error hover:bg-error hover:text-white py-2 border-[1px] border-error rounded-lg flex flex-row items-center justify-center px-3 gap-3 cursor-pointer"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M15.0996 7.55999C14.7896 3.95999 12.9396 2.48999 8.88961 2.48999H8.75961C4.28961 2.48999 2.49961 4.27999 2.49961 8.74999V15.27C2.49961 19.74 4.28961 21.53 8.75961 21.53H8.88961C12.9096 21.53 14.7596 20.08 15.0896 16.54"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8.99988 12H20.3799"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M18.15 8.6499L21.5 11.9999L18.15 15.3499"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <p>خروج از داشبورد</p>
        </div>
      </div>
      {openModal && (
        <ConfirmationModal
          setShowModal={setOpenModal}
          handler={() => {
            ToastSuccess({ content: 'خروج از داشبورد با موفقیت انجام شد' });
            setOpenModal(false);
          }}
          title="خروج از حساب کاربری"
          desc="آیا از خروج از حساب کاربری خود اطمینان دارید؟"
          btnText="تأیید خروج"
        />
      )}
    </div>
  );
}
